import Vue from 'vue';
import Router from 'vue-router';

import scrollBehavior from '@/utils/scroll_behavior';

import routes from './routes';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes,
  scrollBehavior,
});



// WEBPACK FOOTER //
// ./src/router/index.js